package com.exura.features.plandefinition.data.serialization

import com.exura.features.plandefinition.data.remote.dto.element.BasePlanElementDto
import com.exura.features.plandefinition.data.remote.dto.element.FloatingElementDto
import com.exura.features.plandefinition.data.remote.dto.element.InstructionElementDto
import com.exura.features.plandefinition.data.remote.dto.element.PersistentElementDto
import com.exura.features.plandefinition.data.remote.dto.element.QuestionElementDto
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

/**
 * Serializers module specifically for element-related DTOs
 */
val elementSerializersModule = SerializersModule {
    polymorphic(BasePlanElementDto::class) {
        subclass(InstructionElementDto::class)
        subclass(PersistentElementDto::class)
        subclass(QuestionElementDto::class)
        subclass(FloatingElementDto::class)
    }
}
